import Vue from 'vue'
import vueMoment from 'vue-moment'
import moment from 'moment-timezone'

Vue.use(vueMoment, {
  moment,
})
